import * as React from 'react';

import { Text } from '@lightspeed/flame/Text';

import { DownloadAppElement } from 'pages/views/devices/components/DownloadAppElement';
import { useGetAppDownloadUrl } from 'pages/views/devices/hooks/use-get-app-download-url';
import { PLATFORMS } from 'pages/views/devices/types';

interface AlternatePlatformProps {
  platform: PLATFORMS;
}
const AlternatePlatform: React.FC<AlternatePlatformProps> = ({ platform }) => {
  const alternatePlatform = platform === PLATFORMS.MAC ? PLATFORMS.WINDOWS : PLATFORMS.MAC;
  const { appDownloadLinks } = useGetAppDownloadUrl();

  const other = (
    <Text as="span" style={{ textTransform: 'capitalize' }}>
      {alternatePlatform.toLowerCase()}
    </Text>
  );

  return (
    <>
      <Text>Need the {other} version?</Text>
      <DownloadAppElement
        alignItems="center"
        content="Click here."
        url={appDownloadLinks?.[alternatePlatform]}
        ml={1}
      />
    </>
  );
};

export { AlternatePlatform };
